export default "__VITE_ASSET__CrbCcL4D__"